import { render, staticRenderFns } from "./HighlightNotificationItemContentsParts.vue?vue&type=template&id=70cfe653&scoped=true"
import script from "./HighlightNotificationItemContentsParts.vue?vue&type=script&lang=ts"
export * from "./HighlightNotificationItemContentsParts.vue?vue&type=script&lang=ts"
import style0 from "./HighlightNotificationItemContentsParts.vue?vue&type=style&index=0&id=70cfe653&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cfe653",
  null
  
)

export default component.exports